import { lighten, makeStyles } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { useEffect, useRef, useState } from "react";
import { changeAppState } from "../../../../../../common/appState";
import { keys } from "../../../../../../common/util/Object/keys";
import { CountryFlag } from "../../../../../shared/County/CountryFlag";
import {
    CountryCode,
    countryNames,
} from "../../../../../shared/County/countryCodeAndName";
import { User } from "../../../../../shared/User/types";
import { zIndex } from "../../../zIndex";
import { InitialView } from "../MyPageTop/types";

export function HomeCountryField({
    initialView,
    user,
}: {
    initialView?: InitialView;
    user: User;
}) {
    const [nationCode, setNationCode] = useState<CountryCode>("");
    const c = useStyles();
    const [openMenuItems, setOpenMenuItems] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        setNationCode(user.countryCode);
    }, [user.countryCode]);

    useEffect(() => {
        if (initialView === "MyPageHomeCountry") {
            setOpenMenuItems(true);
            changeAppState("signInPanelState", {
                type: "myPageTop",
            });
        }
    }, [initialView]);

    const flagContainerRef = useRef<HTMLDivElement>(null);

    if (nationCode !== "") {
        return (
            <div
                className={c.previewContainer}
                onClick={() => {
                    setNationCode("");
                    setOpenMenuItems(true);
                }}
                ref={flagContainerRef}
            >
                <CountryFlag
                    code={nationCode}
                    className={c.flagInPreview}
                    containerRef={flagContainerRef}
                />
                <span className={c.countryNameInPreview}>
                    {countryNames[nationCode]}
                </span>
            </div>
        );
    }

    return (
        <FormControl
            className={c.formControl}
            disabled={submitting}
            ref={flagContainerRef}
        >
            <InputLabel id="CountrySelectLabel">Home Country</InputLabel>
            <Select
                labelId="CountrySelectLabel"
                value={nationCode}
                onChange={async ev => {
                    const newCode = ev.target.value as Exclude<CountryCode, "">;
                    setNationCode(newCode);
                    setOpenMenuItems(false);

                    setSubmitting(true);
                    const res = await fetchUpdateCountryCode(
                        user.userId,
                        newCode
                    );
                    changeAppState("user", res.user);
                    setSubmitting(false);
                }}
                MenuProps={{
                    style: { zIndex: zIndex.selectMenuItem },
                    ref: flagContainerRef,
                }}
                open={openMenuItems}
                onOpen={() => {
                    setOpenMenuItems(true);
                }}
                onClose={() => {
                    if (user.countryCode) {
                        // 既に設定済みだったら閉じてよし
                        setOpenMenuItems(false);
                    }
                }}
            >
                {keys(countryNames).map(code => (
                    <MenuItem key={code} value={code}>
                        <CountryFlag
                            code={code}
                            className={c.flagInMenuItem}
                            containerRef={flagContainerRef}
                        />
                        <span>{countryNames[code]}</span>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
const useStyles = makeStyles(theme => ({
    previewContainer: {
        marginBottom: 20,
        borderRadius: 5,
        fontSize: "small",
        cursor: "pointer",
        padding: "0 5px",
        "&:hover": {
            backgroundColor: lighten(theme.palette.primary.light, 0.8),
        },
    },
    flagInPreview: {
        marginRight: 5,
    },
    countryNameInPreview: { color: theme.palette.grey[600] },

    formControl: { minWidth: 210, marginBottom: 20 },
    flagInMenuItem: { marginLeft: 5, marginRight: 15 },
}));

async function fetchUpdateCountryCode(
    userId: number,
    countryCode: CountryCode
): Promise<{ user: User }> {
    const formData = new FormData();
    formData.append("userId", userId.toString());
    formData.append("countryCode", countryCode);

    const res = await fetch("api/User/UpdateCountryCode", {
        method: "POST",
        body: formData,
    });
    return res.json();
}

